import { Box, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import useServerStateContext from '@/shared/hooks/useServerStateContext';
import { BackButton } from '@/features/ses/components/BackButton';
import { framingTarget } from '../store/framingTargetStore';

const BACK_LABEL = 'Back without changing the clip';

/**
 * Stands in for the Manual / Auto-ISO toggle while a Fixed Camera Clip aims at
 * a spot: the panel is in neither mode then, so it names the job, the same way
 * the clip panel does, with the usual back arrow as the way out.
 */
export const TargetModeBar = ({ sx }: { sx?: object }) => {
  const { cx } = useTheme().palette;
  const { selectedCamera } = useServerStateContext();
  return (
    <Stack
      data-testid="target-mode-bar"
      direction="row"
      spacing={1}
      sx={[{ alignItems: 'center', minWidth: 0 }, sx ?? {}]}
    >
      <Tooltip title={BACK_LABEL}>
        <span>
          <BackButton aria-label={BACK_LABEL} onClick={() => framingTarget.end()} />
        </span>
      </Tooltip>
      <Typography
        noWrap
        sx={{
          minWidth: 0,
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '16px',
          color: cx.text.primary,
        }}
      >
        Aim at a spot on the rink
        {selectedCamera && (
          <Box component="span" sx={{ ml: 1, fontWeight: 400, color: cx.text.tertiary }}>
            {selectedCamera.displayName}
          </Box>
        )}
      </Typography>
    </Stack>
  );
};

export default TargetModeBar;
